import React from "react"
import { Canvas } from "@agenteresolve/react"
import { useTranslation } from "react-i18next"
import useDesignEditorContext from "~/hooks/useDesignEditorContext"
import { CONTENT_KINDS, unitLabelKey } from "~/constants/content-kinds"
import { formatSizeLabel } from "~/constants/formats"
import ContextMenu from "../ContextMenu"
import HyperFramesLive from "./HyperFramesLive"

export default function () {
  const { displayAnimation, setDisplayAnimation, currentScene, scenes, contentKind, activeFormat } = useDesignEditorContext()
  const { t } = useTranslation("editor")
  const isStaticMode = !CONTENT_KINDS[contentKind].animated
  const sceneIndex = Math.max(
    0,
    scenes.findIndex((scene) => scene.id === currentScene?.id)
  )

  React.useEffect(() => {
    if (isStaticMode && displayAnimation) setDisplayAnimation(false)
  }, [isStaticMode, displayAnimation, setDisplayAnimation])

  return (
    <div className="ar-stage">
      <ContextMenu />
      <Canvas
        config={{
          background: "#f1f2f6",
          controlsPosition: {
            rotation: "BOTTOM",
          },
          shadow: {
            blur: 4,
            color: "#fcfcfc",
            offsetX: 0,
            offsetY: 0,
          },
        }}
      />
      <span className="ar-page-chip">
        {t(unitLabelKey(contentKind), CONTENT_KINDS[contentKind].unit)} {sceneIndex + 1}
        <span className="ar-page-chip-total">/ {Math.max(1, scenes.length)}</span>
      </span>
      {activeFormat && (
        <span className="ar-format-chip">
          {formatSizeLabel(activeFormat)}
          {activeFormat.unit === "mm" && (
            <>
              {" · "}
              {t("formats.bleedShort", "sangria")} {activeFormat.bleed} mm
              {" · "}
              {t("formats.safeShort", "área segura")} {activeFormat.safe} mm
            </>
          )}
        </span>
      )}
      {!isStaticMode && (
        <button
          type="button"
          className={`ar-stage-action ${displayAnimation ? "on" : ""}`}
          onClick={() => setDisplayAnimation((value) => !value)}
        >
          {displayAnimation ? t("canvas.edit") : t("canvas.animate")}
        </button>
      )}
    </div>
  )
}
